<template>
    <div>
        <ModuleTitleNav :next-module="nextModule" :previous-module="previousModule" class="title-one">
            {{ moduleTitle }}
        </ModuleTitleNav>
        <div class="section-line" />
        <fieldset :disabled="formDisabled">
            <b-form-row>
                <b-col>
                    <div class="info-text">
                        Describe how the college, in collaboration with local workforce development boards and
                        other local workforce agencies, one-stop delivery systems described in section 121(e)(2)
                        of the Workforce Innovation and Opportunity Act (29 U.S.C. 3151(e)(2)), and other
                        partners, will provide—
                    </div>
                </b-col>
            </b-form-row>
            <b-form-row>
                <b-col>
                    <div class="info-text-section-marker">
                        [Sec 134 (b)(3)(A)]
                    </div>
                    <div class="info-text">
                        Career exploration and career development coursework, activities, or services.
                    </div>
                    <b-form-textarea
                        v-model="exploration"
                        :rows="3"
                    />
                </b-col>
            </b-form-row>
            <br>
            <b-form-row>
                <b-col>
                    <div class="info-text-section-marker">
                        [Sec 134 (b)(3)(B)]
                    </div>
                    <div class="info-text">
                        Career information on employment opportunities that incorporate the most up to-date
                        information on high-skill, high-wage, or in-demand industry sectors or occupations, as
                        determined by the comprehensive needs assessment.
                    </div>
                    <b-form-textarea
                        v-model="information"
                        :rows="3"
                    />
                </b-col>
            </b-form-row>
            <br>
            <b-form-row>
                <b-col>
                    <div class="info-text-section-marker">
                        [Sec 134 (b)(3)(C)]
                    </div>
                    <div class="info-text">
                        An organized system of career guidance and academic counseling designed to aid students,
                        in making informed plans and decisions about future education and career opportunities and
                        programs of study to students before enrolling and while participating in a career and
                        technical education program.
                    </div>
                    <div class="info-text-emphasis">
                        <b-link :to="{name: 'localApplication.CareerExplorationAndDevelopment'}">
                            See also Local Uses of Funds [Sec 135(b)(1)]
                        </b-link>
                    </div>
                    <b-form-textarea
                        v-model="guidanceSystem"
                        :rows="3"
                    />
                </b-col>
            </b-form-row>
            <br>
        </fieldset>
        <b-form-row>
            <b-col>
                <LocalApplicationModuleActions
                    :is-loading="isSaving"
                    :is-disabled="formDisabled"
                    background-color="#006438"
                    @saveForm="saveForm"
                />
            </b-col>
        </b-form-row>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { Log } from '$Shared/@arc/vue-arc';

const storeModuleName = 'wibCollaboration';
// const storeModuleNamespace = 'localApplications/module';

export default {
    name: 'WibCollaboration',

    props: {
        // formDisabled: { type: Boolean, default: true },
    },

    data() {
        return {
            isSaving: false,
            moduleTitle: 'WIB Collaboration',
            nextModule: { name: 'localApplication.StrengthenAcademicAndTechnicalSkills' },
            previousModule: { name: 'localApplication.CteOfferings' },
        };
    },

    computed: {
        ...mapState('localApplication', {
            currentState: (state) => state.localApplicationData.state.currentState
        }),

        ...mapGetters({
            isAuthorized: 'auth/isAuthorized',
            localApplicationModuleContent: `localApplication/module/${storeModuleName}/content`
        }),

        formDisabled() {
            return !this.isAuthorized('update', 'local_application', this.currentState);
        },

        exploration: {
            get() { return this.localApplicationModuleContent.exploration; },
            set(value) { this.updateContentField({ field: 'exploration', value }); }
        },

        information: {
            get() { return this.localApplicationModuleContent.information; },
            set(value) { this.updateContentField({ field: 'information', value }); }
        },

        guidanceSystem: {
            get() { return this.localApplicationModuleContent.guidanceSystem; },
            set(value) { this.updateContentField({ field: 'guidanceSystem', value }); }
        },
    },

    methods: {
        ...mapActions(`localApplication/module/${storeModuleName}`, {
            saveLocalApplicationModule: 'save',
            updateContentField: 'updateContentField'
        }),

        async saveForm() {
            this.isSaving = true;
            try {
                const response = await this.saveLocalApplicationModule();
                this.isSaving = false;
                Log.debug(response, `COMPONENT:${this.name} -> Save module response:`);
            } catch (error) {
                this.isSaving = false;
            }
        }
    }
};
</script>
